module.exports = "https://la-static.vkplay.ru/promo/newstart/img/souleater.e01174a8.png";